document.addEventListener("DOMContentLoaded", () => {

  const flavorColors = {

    "lime": {
      background: "#C6FFA2",
      text: "#047E41",
      border: "#047E41",
      button: "#047E41",
      buttonText: "#C6FFA2",

      subscriptionBackground: "#047E41",
      subscriptionText: "#C6FFA2",
      subscriptionBorder:"#C6FFA2"
      
    },

    "lime cream": {
      background: "#047E41",
      text: "#C6FFA2",
      border: "#C6FFA2",
      button: "#C6FFA2",
      buttonText: "#047E41",

      subscriptionBackground: "#48C072",
      subscriptionText: "#C6FFA2",
      subscriptionBorder:"#C6FFA2"
      
    },

    "lemon": {
      background: "#EBCD0B",
      text: "#FFF6B9",
      border: "#B28D31",
      button: "#FFF6B9",
      buttonText: "#C2B206",

      subscriptionBackground: "#E0BD04",
      subscriptionText: "#FFF6B9",
      subscriptionBorder:"#FFF6B9" 
    },

    "lemon cream": {
      background: "#FFF6B9",
      text: "#EBC20B",
      border: "#EBC20B",
      button: "#EBC20B",
      buttonText: "#FFF6B9",

      subscriptionBackground: "#EBC20B",
      subscriptionText: "#FFF6B9",
      subscriptionBorder:"#FFF6B9" 
    },

    "orange": {
      background: "#F26522",
      text: "#FFD5B2",
      border: "#FFD5B2",
      button: "#FFD5B2",
      buttonText: "#F26522",

      subscriptionBackground: "#E85C1C",
      subscriptionText: "#FFD5B2",
      subscriptionBorder:"#FFD5B2"
    },

    "orange cream": {
      background: "#FFD0AA",
      text: "#EB530B",
      border: "#EB530B",
      button: "#EB530B",
      buttonText: "#FFD0AA",

      subscriptionBackground: "#EB530B",
      subscriptionText: "#FFD0AA",
      subscriptionBorder:"#FFD0AA"
    },

    "vanilla cream": {
      background: "#543A1F",
      text: "#FFFFFF",
      border: "#FFFFFF",
      button: "#FFFFFF",
      buttonText: "#543A1F",

      subscriptionBackground: "#FFFFFF",
      subscriptionText: "#543A1F",
      subscriptionBorder:"#543A1F"
    },

    "sweet 'n spicey": {
      background: "#361901",
      text: "#C5AC92",
      border: "#C5AC92",
      button: "#C5AC92",
      buttonText: "#361901",

      subscriptionBackground: "#C5AC92",
      subscriptionText: "#361901",
      subscriptionBorder:"#361901"
    },

    "a little bit of everything pack": {
      background: "#002060",
      text: "#3CA7BD",
      border: "#3CA7BD",
      button: "#3CA7BD",
      buttonText: "#002060",

      subscriptionBackground: "#3CA7BD",
      subscriptionText: "#002060",
      subscriptionBorder:"#002060"
    },

    "cream variety pack": {
      background: "#EEB67D",
      text: "#6A4A27",
      border: "#6A4A27",
      button: "#6A4A27",
      buttonText: "#EEB67D",

      subscriptionBackground: "#6A4A27",
      subscriptionText: "#EEB67D",
      subscriptionBorder:"#EEB67D"
    },

    "mixers pack": {
      background: "#B8D8E8",
      text: "#315A70",
      border: "#315A70",
      button: "#315A70",
      buttonText: "#B8D8E8"
    },

    "surprise me!": {
      background: "#000000",
      text: "#FFFFFF",
      border: "#FFFFFF",
      button: "#FFFFFF",
      buttonText: "#000000",

      subscriptionBackground: "#252525",
      subscriptionText: "#FFFFFF",
      subscriptionBorder:"#FFFFFF"
    }
  };


  /*
   * Find the currently selected flavor.
   */
  function getSelectedFlavor() {

    const input = document.querySelector(
      'input[data-option-name="Flavor"]:checked'
    );

    if (!input) {
      return null;
    }

    return input.value.trim().toLowerCase();
  }


  /*
   * Find the product-information section.
   */
  function getProductSection() {

    const input = document.querySelector(
      'input[data-option-name="Flavor"]:checked'
    );

    if (input) {

      const section = input.closest(
        '[data-testid="product-information"]'
      );

      if (section) {
        return section;
      }
    }

    return document.querySelector(
      '[data-testid="product-information"]'
    );
  }

    /*
   * Find the "Never-Ending Flavor" section.
   */
  function getTopFlavorSection() {

    const sections =
      document.querySelectorAll("section");

    for (const section of sections) {

      if (
        section.textContent.includes(
          "Never-Ending Flavor"
        )
      ) {
        return section;
      }

    }

    return null;
  }


  /*
   * Apply all flavor colors.
   */
  function applyColors(flavor) {

    const colors = flavorColors[flavor];

    if (!colors) {
      console.warn(
        "Flavor color not found:",
        flavor
      );

      return;
    }


    const productSection = getProductSection();

    if (!productSection) {
      return;
    }




    /*
     * Save colors as CSS variables.
     */
    productSection.style.setProperty(
      "--flavor-background",
      colors.background
    );

    productSection.style.setProperty(
      "--flavor-text",
      colors.text
    );

    productSection.style.setProperty(
      "--flavor-border",
      colors.border
    );

    productSection.style.setProperty(
      "--flavor-button",
      colors.button
    );

    productSection.style.setProperty(
      "--flavor-button-text",
      colors.buttonText
    );

   document.documentElement.style.setProperty(
  "--subscription-background",
  colors.subscriptionBackground
);

document.documentElement.style.setProperty(
  "--subscription-text",
  colors.subscriptionText
);

document.documentElement.style.setProperty(
  "--subscription-border",
  colors.subscriptionBorder
);


    /*
     * Add our active class.
     */
    productSection.classList.add(
      "flavor-color-active"
    );


    /*
     * Direct product-section colors.
     */
    productSection.style.setProperty(
      "background-color",
      colors.background,
      "important"
    );

    productSection.style.setProperty(
      "color",
      colors.text,
      "important"
    );


    /*
     * Find the current flavor buttons.
     */
    const flavorInputs =
      productSection.querySelectorAll(
        'input[data-option-name="Flavor"]'
      );


    flavorInputs.forEach((input) => {

      const button = input.closest(
        ".variant-option__button-label"
      );

      if (!button) {
        return;
      }


      /*
       * Remove previous inline styles.
       */
      button.style.removeProperty(
        "background-color"
      );

      button.style.removeProperty(
        "color"
      );

      button.style.removeProperty(
        "border-color"
      );


      /*
       * Selected flavor button.
       */
      if (input.checked) {

        button.style.setProperty(
          "background-color",
          colors.button,
          "important"
        );

        button.style.setProperty(
          "color",
          colors.buttonText,
          "important"
        );

        button.style.setProperty(
          "border-color",
          colors.button,
          "important"
        );


        /*
         * Force the flavor name to use
         * the selected-button text color.
         */
        const textElements =
          button.querySelectorAll(
            "span, label, div"
          );


        textElements.forEach((element) => {

          element.style.setProperty(
            "color",
            colors.buttonText,
            "important"
          );

        });

      }


      /*
       * Unselected flavor buttons.
       */
      else {

        button.style.setProperty(
          "background-color",
          "transparent",
          "important"
        );

        button.style.setProperty(
          "color",
          colors.text,
          "important"
        );

        button.style.setProperty(
          "border-color",
          colors.border,
          "important"
        );

      }

    });


    /*
     * Remember which flavor was applied.
     */
    productSection.dataset.appliedFlavor =
      flavor;

  }


  /*
   * Wait until the selected flavor has
   * finished updating.
   */
  function waitForFlavor(flavor) {

    let attempts = 0;

    const maxAttempts = 40;


    function check() {

      attempts++;

      const currentFlavor =
        getSelectedFlavor();


      /*
       * The flavor hasn't updated yet.
       */
      if (currentFlavor !== flavor) {

        if (attempts < maxAttempts) {

          requestAnimationFrame(check);

        }

        return;
      }


      /*
       * Apply the correct colors.
       */
      applyColors(currentFlavor);

    }


    requestAnimationFrame(check);

  }


  /*
   * Handle flavor selection.
   */
  document.addEventListener(
    "change",
    (event) => {

      const input = event.target;


      if (
        input.matches(
          'input[data-option-name="Flavor"]'
        )
      ) {

        const flavor =
          input.value.trim().toLowerCase();


        waitForFlavor(flavor);

      }

    }
  );


  /*
   * Handle Horizon's variant update event.
   */
  document.addEventListener(
    "variant:update",
    () => {

      const flavor =
        getSelectedFlavor();


      if (flavor) {

        waitForFlavor(flavor);

      }

    }
  );


  /*
   * Watch for changes inside the product
   * information section.
   */
  const productSection =
    document.querySelector(
      '[data-testid="product-information"]'
    );


  if (productSection) {

    const observer =
      new MutationObserver(() => {

        const flavor =
          getSelectedFlavor();


        if (!flavor) {
          return;
        }


        const section =
          getProductSection();


        if (!section) {
          return;
        }


        /*
         * Only reapply if Horizon has
         * changed the product section.
         */
        if (
          section.dataset.appliedFlavor !==
          flavor
        ) {

          applyColors(flavor);

        }

      });


    observer.observe(
      productSection,
      {
        childList: true,
        subtree: true
      }
    );

  }


  /*
   * Initial page load.
   */
  const initialFlavor =
    getSelectedFlavor();


  if (initialFlavor) {

    waitForFlavor(
      initialFlavor
    );

  }

});